import Header from "./Header";
import Footer from "./Footer";
import Navigation from "./Navigation";

export default function Coupon() {
  return (
    <div>
    <div className="sticky-wrap" style={{ minHeight: "71.1875px" }}>
      <Header />
    </div>
    <div
      className="title"
      style={{ textAlign: "center", fontSize: 30, marginBottom: "20px" }}
    >
      쿠폰 이용약관
    </div>
    <Navigation />
    <div style={{ width: "100%" }}>
      <div>
        <div id="privacy-section-1">
          <div className="privacy-section-in inlineon">
          <h2>제1조 (목적)</h2>
          <p className="mgbotm40">
          본 약관은 주식회사 불타는고구마 이 제공하는 쿠폰(이하 “쿠폰”)의 발급 및 이용과 관련하여 회사와 회원 간의 권리·의무 및 책임 사항을 규정함을 목적으로 합니다.
          </p>
          <h2>제2조 (쿠폰의 정의)</h2>
          <p className="mgbotm40">
            쿠폰은 회사가 정한 조건에 따라 발급되며, 유료 서비스 결제 시 할인 또는 혜택받을 수 있는 전자적 증표를 말합니다.
            <br />
            쿠폰의 구체적인 혜택, 조건, 유효기간은 발급 시점에 고지된 내용에 따릅니다.
          </p>
          <h2>제3조 (쿠폰의 사용)</h2>
        <ol className="list-indent">
          <li style={{ marginBottom: '10px' }}>
            <ol className="list-none-style">
              <li className="list-ol-decimal">쿠폰은 회사가 지정한 서비스에서만 사용할 수 있습니다.</li>
              <li className="list-ol-decimal">쿠폰은 결제 시 명시된 조건에 따라 사용할 수 있으며, 일부 상품 또는 이벤트와 중복 적용이 제한될 수 있습니다.</li>
              <li className="list-ol-decimal">쿠폰은 유효기간 내에서만 사용할 수 있으며, 기간이 만료된 쿠폰은 자동으로 소멸합니다.</li>
              <li className="list-ol-decimal">회사의 시스템을 악용하거나 서비스 운영을 방해하는 경우</li>
            </ol>
          </li>
      </ol>
      <p className="mgbotm40"></p>
          <h2>제4조 (쿠폰의 제한 및 소멸)</h2>
<ol className="list-indent">
  <li style={{ marginBottom: '10px' }}>
    다음 각 호에 해당하면 쿠폰의 사용이 제한되거나 무효가 될 수 있습니다.
    <ol className="list-ol">
      <li>부정한 방법으로 발급 또는 취득한 경우</li>
      <li>회사의 시스템을 악용하거나 서비스 운영을 방해하는 경우</li>
      <li>기타 약관 및 정책을 위반한 경우</li>
    </ol>
  </li>
  <li>사용한 쿠폰이 적용된 결제를 취소할 경우, 해당 쿠폰은 반환되지 않고 소멸됩니다.</li>
  <li>회사는 부득이한 사정이 있는 경우, 사전 고지 후 쿠폰의 사용 조건을 변경하거나 발급을 중단할 수 있습니다.</li>
  <li>회사는 운영상 필요, 오류, 또는 부정 이용이 확인된 경우 사전 통지 없이 쿠폰 발급을 취소하거나 회수할 수 있습니다.
  </li>


</ol>
<p className="mgbotm40"></p>
          <h2>제5조 (쿠폰의 양도 및 거래 금지)</h2>
          <ol className="list-indent">
            <li>회원은 발급받은 쿠폰을 제삼자에게 양도, 매매, 담보 제공, 현금화할 수 없습니다.</li>
            <li>이를 위반하여 발생하는 불이익에 대하여 회사는 책임을 지지 않습니다.</li>
          </ol>
          <p className="mgbotm40"></p>
          <h2>제6조 (쿠폰의 환불)</h2>
          <ol className="list-indent">
            <li>유상 쿠폰은 서비스 이용 전 취소 시 환불이 가능합니다.</li>
            <li>유상 쿠폰 사용 후 서비스 혜택을 받지 않은 경우 환불이 가능합니다.</li>
            <li>유상 쿠폰 사용 후 서비스 혜택을 받은 경우 환불은 불가능합니다.</li>
            <li>무료 쿠폰 사용 후 서비스 혜택을 받은 경우 환불은 불가능합니다.
            </li>
            <li>유상쿠폰 구매 후 미사용으로 인한 만료된 쿠폰은 환불이 불가합니다.</li>
            <li>환불 시 회사는 결제수단 또는 회사가 정한 방법(포인트, 쿠폰 등)으로 환불할 수 있으며, 현금 환불은 제한될 수 있습니다.</li>
          </ol>
          <p className="mgbotm40"></p>
          <h2>제7조 (쿠폰의 환불)</h2>
          <ol className="list-indent">
            <li>쿠폰의 사용과 관련하여 회원이 고의 또는 과실로 발생시킨 손해에 대해 회사는 책임을 지지 않습니다.</li>
            <li>회사는 천재지변, 시스템 오류, 외부 요인 등 불가항력적인 사유로 인한 쿠폰 사용 불가에 대해 책임지지 않습니다.</li>
          </ol>
          <p className="mgbotm40"></p>
          <h2>제8조 (쿠폰의 환불)</h2>
          <p className="mgbotm40">
            회사는 서비스 운영상 필요에 따라 쿠폰의 정책(혜택, 유효기간, 사용 조건 등)을 변경할 수 있으며, 변경 사항은 사전에 고지 후 적용됩니다.
          </p>
          <p className="mgbotm40"></p>
          <h2>제9조 (준거법 및 관할)</h2>
          <p className="mgbotm40">
            본 약관은 대한민국 법률에 따르며, 쿠폰 이용과 관련하여 회사와 회원 간 발생한 분쟁에 대해서는 회사 본사 소재지를 관할하는 법원을 전속 관할 법원으로 합니다.
          </p>
          <p className="mgbotm40"></p>
            <ul className="agree_ul mgbotm40">
              <li className="pd0">공고일자: 2025년 09월 29일</li>
              <li className="pd0">공고일자: 2025년 09월 29일</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
  );
}
